// extracted by mini-css-extract-plugin
module.exports = {"swap-item__bttn-img":"swap-item__bttn-img--8jbxz"};